// Maintenance renewal invoices. Shared by the dashboard renewals widget and
// the account's Renewal panel so both draft the same invoice.

export const DEFAULT_MAINTENANCE_CENTS = 350000;

// Tagged so signing the invoice starts the next service term.
export function maintenanceLineItems(amountCents, year) {
  return [{
    description: `12-Month Maintenance — Year ${year || 2}`,
    qty: 1,
    unitCostDollars: (Number(amountCents) || DEFAULT_MAINTENANCE_CENTS) / 100,
    product_type: 'maintenance_renewal',
  }];
}

// NewInvoiceDialog prefill for renewing `term` (the current term) of a school.
export function renewalInvoicePrefill({ account, term, projectId, amountCents }) {
  return {
    account: { id: account.id, name: account.name, type: account.type || 'school' },
    validThrough: term?.endsOn || term?.renewalDueDate || undefined,
    taxExempt: true,
    projectId: projectId || term?.projectId || undefined,
    lineItems: maintenanceLineItems(amountCents, (term?.termNumber || 1) + 1),
    signatureRequired: false, // opt-in per invoice (2026-10-09)
  };
}
